



















import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'Forbidden'
})
export default class Forbidden extends Vue {
  goHome() {
    window.location.href = '/wap/home'
  }
}
